import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  recordedLessonsData: [],
  totalrecordedLessons: 0,
  isOpenModal: false,
  isImageOpenModal: false,
}

export const recordedLessonsSlice = createSlice({
  name: "recordedLessons",
  initialState,
  reducers: {
    setrecordedLessonsData(state, { payload }) {
      state.recordedLessonsData = payload.result
      state.totalrecordedLessons = payload.count
    },
    updaterecordedLessonsData(state, { payload }) {
      const objIndex = state.recordedLessonsData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.recordedLessonsData[objIndex] = payload
      }
    },
    deleterecordedLessonsData(state, { payload }) {
      const objIndex = state.recordedLessonsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.recordedLessonsData.splice(objIndex, 1)
      }
    },
    pushrecordedLessonsData(state, { payload }) {
      state.recordedLessonsData.push(payload)
      state.totalrecordedLessons = + 1
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isImageOpenModal(state, { payload }) {
      state.isImageOpenModal = payload
    },
    ImagestatusToggle(state, { payload }) {
      state.isImageOpenModal = !state.isImageOpenModal
    }
  }
})

export const { setrecordedLessonsData, updaterecordedLessonsData, deleterecordedLessonsData, pushrecordedLessonsData, isOpenModal,
  ModalToggle,ImagestatusToggle, isImageOpenModal } = recordedLessonsSlice.actions;

export default recordedLessonsSlice.reducer;

export function getrecordedLessons(limit, offset, id) {
  return async function getrecordedLessonsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getrecordedLessons(limit, offset, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setrecordedLessonsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addrecordedLessons(payload) {
  return async function addrecordedLessonsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addrecordedLessons(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushrecordedLessonsData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updaterecordedLessons(id, data) {
  return async function updaterecordedLessonsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updaterecordedLessons(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updaterecordedLessonsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateRecordedLessonsVideo(id, video) {
  return async function updateRecordedLessonsVideoThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      dispatch(isImageOpenModal())
      await service.recordedLessonsVideo(id, video).then(
        (response) => {
          dispatch(updaterecordedLessonsData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function statusDeleterecordedLessons(id) {
  return async function statuseleterecordedLessonsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdaterecordedLessons(id).then(
        (response) => {
          dispatch(deleterecordedLessonsData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



